<template>
  <div class="hero-section" :style="{ backgroundImage: 'url(' + image + ')' }">
    <div class="hero-wrap">
      <div class="no-overflow">
        <div class="hero-block">
          <div class="left-border"></div>
          <!--<h1 class="heading">Peste jumătate de secol <br>de excelență în muzică corală</h1>-->
          <!--          <a href="/florilegiu" class="link" target="_blank"><h1 class="heading">Marin Constantin<br/>"Florilegiu bizantin" (fragment)</h1></a>-->
          <a href="https://youtu.be/9Lpznktvv0Y" class="link" target="_blank">
            <h1 class="heading">{{ $t("home.headingTitle") }}<br>{{ $t("home.headingTitle2") }}</h1>
            <h3 class="heading">{{ $t("home.headingDescription") }}<br>{{ $t("home.headingDescription2") }}</h3><br>
            <h3 class="heading" style="color: #fbffc2; font-weight: 600">
              {{ $t("home.headingCallToAction") }}
            </h3>
          </a>
          <div class="right-border"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Header",
  data() {
    return {
      image: require("../assets/images/Hero-back.png"),
    };
  },
};
</script>

<style scoped lang="scss">
.link {
  color: white;
  text-shadow: 0 14px 50px rgba(5, 29, 47, 0.85);
}

.hero-section {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: row;
  height: 100vh;
  background: #2f82bb no-repeat scroll 50% 50%;
  background-size: cover;
}

.hero-wrap {
  position: relative;
  display: block;
  width: 1054px;
  margin-right: auto;
  margin-left: auto;
  padding-right: 112px;
  padding-left: 112px;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  color: #fff;
}

.no-overflow {
  position: relative;
  overflow: hidden;
  padding-top: 82px;
}

.hero-block {
  position: relative;
  padding-bottom: 25px;
  border: 4px solid #fff;
  border-top-style: none;
  text-align: center;
}

.heading {
  position: relative;
  top: -48px;
  display: inline-block;
  padding-right: 29px;
  padding-left: 29px;
  font-family: Roboto, sans-serif;
  font-size: 4em;
  line-height: 1.2em;
  letter-spacing: 1.5px;
}

h3.heading {
  font-size: 2em;
  margin: 0.5em 0;
}

h4.heading {
  font-size: 1.5em;
  margin: 0.5em 0;
}

.heading:hover {
  color: #cccccc;
}

.right-border {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  display: inline-block;
  width: 50px;
  height: 4px;
  clear: none;
  background-color: #fff;
}

.left-border {
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  display: inline-block;
  width: 50px;
  height: 4px;
  clear: none;
  background-color: #fff;
}

@media (max-width: 991px) {
  .hero-wrap {
    width: 850px;
    padding: 0 10vw;
  }

  .heading {
    font-size: 3em;
    line-height: 1.1em;
    top: -75px;
  }

  .left-border,
  .right-border {
    width: 40px;
  }
}

@media (max-width: 767px) {
  .hero-wrap {
    width: 100%;
  }

  .heading {
    font-size: 2em;
    line-height: 1em;
    top: -52px;
  }

  .left-border,
  .right-border {
    width: 20px;
  }
}

@media (max-width: 479px) {
  .hero-wrap {
    padding: 0 3vw;
    top: -40px;
  }

  .left-border,
  .right-border {
    width: 10px;
  }
}
</style>
